import React, { createContext } from 'react';
import { useDispatch } from 'react-redux';
import io from 'socket.io-client';
import { handlePrivateApiErrors } from '../../lib/api-errors';
import {
  _process3210,
  _process3220,
  _process3250,
  _process3310,
  _process6210,
  _process6220,
  _process9100,
} from '../../utils/priceboard';
import {
  receive1101,
  receive3211,
  receive3220,
  receiveReregister,
  serverOff,
  socketReady,
} from './actions';

import { w3cwebsocket as W3CWebSocket } from 'websocket';

import { deserialize } from '../../lib/msgPack';
import { hmsToSeconds } from '../../utils';

// const socketUrl = `${process.env.REACT_APP_SOCKET_URL}`;
const socketNativeUrl = `${process.env.REACT_APP_NATIVE_URL}`;
const socketMode = `${process.env.REACT_APP_SOCKET_MODE}`;

const WebSocketContext = createContext(null);

export { WebSocketContext };

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

export default ({ children, store }) => {
  let socket;
  let ws;

  let countPing = 0;
  let interval, timer;
  let renderQueue = [],
    mounted = false;

  const dispatch = useDispatch();

  React.useEffect(() => {
    window.addEventListener('hashchange', handleChange);
    document.addEventListener('visibilitychange', handleActivity);

    const d = new Date();
    // const diffSecond =
    //   hmsToSeconds(d.getHours() + ':' + d.getHours() + ':' + d.getSeconds()) -
    //   hmsToSeconds('15:00:00');
    if (!timer)
      timer = setInterval(processUpdateCell, 5 * 10);

    return () => {
      window.removeEventListener('hashchange', handleChange);
      document.removeEventListener('visibilitychange', handleActivity);

      if (interval) clearInterval(interval);
      if (timer) {
        clearInterval(timer);
        timer = undefined;
      }
      renderQueue = [];
    };
  }, []);

  function handleActivity() {
    console.log('clear queue');
    renderQueue = [];
  }

  function handleChange() {
    const pathname = window.location.hash;
    const d = new Date();
    // const diffSecond =
    //   hmsToSeconds(d.getHours() + ':' + d.getHours() + ':' + d.getSeconds()) -
    //   hmsToSeconds('15:00:00');
    // console.log(pathname, diffSecond, timer);
    if (pathname.indexOf('/home/bang-gia') > -1) {
      if (!timer) timer = setInterval(processUpdateCell, 5 * 10);
    } else {
      if (timer) {
        clearInterval(timer);
        timer = undefined;
      }
      renderQueue = [];
    }
  }

  const sendMessage = (message) => {
    console.log(message);
    if (!socket) return;
    if (socketMode === 'native') {
      var buf = str2ab(message);
      if (message.action === 'join') {
        socket.send(buf, (dt) => {
          console.log(dt);
          if (dt === 'OK') {
            dispatch({ type: 'REGISTER_OK' });
          } else {
            dispatch({ type: 'REGISTER_NOT_OK' });
          }
        });
      } else {
        socket.send(buf);
      }
    } else {
      if (message.action === 'join') {
        socket.emit('regs', JSON.stringify(message), (dt) => {
          console.log(dt);
          if (dt === 'OK') {
            dispatch({ type: 'REGISTER_OK' });
          } else {
            dispatch({ type: 'REGISTER_NOT_OK' });
          }
        });
      } else {
        socket.emit('regs', JSON.stringify(message));
      }
    }
  };

  const processUpdateCell = () => {
    mounted = true;

    const _processData = renderQueue.splice(0, 10);
    // console.log(renderQueue.length)
    mounted = false;
    _processData.forEach((element) => {
      if (element.id === 3220) _process3220(element);
      if (element.id === 3210) _process3210(element);
      if (element.id === 3250) _process3250(element);
      if (element.id === 3310) _process3310(element);
    });
  };

  const processTimeIndex = (msg1101) => {
    // const time = msg1101.time;
    // const diffSecond = hmsToSeconds(time) - hmsToSeconds('15:00:00');
    // // console.log(diffSecond)
    // if (diffSecond > 0) {
      if (timer) {
        clearInterval(timer);
        timer = undefined;
      }
      renderQueue = [];
    // }
  };

  const sendPing = () => {
    console.log('ping server', countPing);
    // if (countPing > 4) {
    //   return dispatch(serverOff());
    // }

    countPing++;

    let msg = { action: 'ping', mode: 'sync', data: ' ' };
    if (socketMode === 'native') {
      var buf = str2ab(JSON.stringify(msg));
      socket.send(buf);
    } else {
      socket.emit('regs', JSON.stringify(msg), (data) => {
        dispatch(socketReady());
        countPing = 0;
        if (data === '6666') dispatch(receiveReregister(true));
      });
    }
  };

  const reconnectTrigger = () => {
    console.log(socket);
    if (socket) socket.connect();
  };

  const init = () => {
    if (!socket) {
      console.log(process.env);
      if (socketMode === 'native') {
        // native socket
        socket = new W3CWebSocket(socketNativeUrl);
        socket.binaryType = 'arraybuffer';

        socket.onopen = function (event) {
          console.log('connected');
          dispatch(socketReady());
        };

        socket.onmessage = function (event) {
          if (event.data instanceof ArrayBuffer) {
            var buffer = event.data;
            const _data = ab2str(buffer);
            console.log(_data);
            if (_data) publicHandler(_data, dispatch);
          }
        };

        socket.onclose = function (event) {
          console.log('disconnect');
          dispatch(serverOff());
        };
      } else {
        const _st = store.getState();
        // console.log(store, _st.client.config.config)

        socket = io.connect(_st.client.config.config.ws, {
          autoConnect: false,
          reconnection: false,
          // reconnectionDelay: 1000,
          // reconnectionAttempts: 5,
          // forceNew: true,
        });

        socket.on('connect', () => {
          console.log('connected');
          dispatch(socketReady());
        });

        socket.on('reconnect', () => {
          console.log('reconnect');
          dispatch(socketReady());
        });

        socket.on('disconnect', (reason) => {
          // if (reason === 'io server disconnect') {
          //   console.log('disconnect', 'io server disconnect');
          //   dispatch(serverOff());
          //   socket.connect();
          // }
          dispatch(serverOff());
          init();
        });

        socket.on('reconnect_failed', () => {
          console.log('reconnect_failed');
          dispatch(serverOff());
        });

        socket.on('reconnect_error', () => {
          dispatch(serverOff());
        });

        socket.on('public', (msg) => {
          // dispatch(socketReady());
          // publicHandler(msg, dispatch);
          const payload = msg.data;
          if (!payload) return;

          switch (payload.id) {
            case 6666:
              dispatch(receiveReregister(true));
              break;
            case 1101:
              processTimeIndex(payload);
              dispatch(socketReady());
              dispatch(receive1101(payload));
              break;
            case 3211:
              // ntp data
              dispatch(receive3211(payload));
              break;
            case 3210:
              // _process3210(payload);
              if (!mounted) renderQueue.push(payload);
              break;
            case 3220:
            case 3223:
              // _process3220(payload);
              if (!mounted) renderQueue.push(payload);
              // if (payload.sym.startsWith('VN30')) {
              //   // dispatch mess 3220
              //   dispatch(receive3220(payload));
              // }
              break;
            case 3250:
              // _process3250(payload);
              if (!mounted) renderQueue.push(payload);
              break;
            case 9100:
              _process9100(payload);
              break;
            case 3310:
              _process3310(payload);
              break;
            // lô lẻ
            case 6210:
              _process6210(payload);
              break;
            case 6220:
              _process6220(payload);
              break;
            default:
              break;
          }
        });

        socket.on('private', (msg) => {
          const action = msg.action;
          if (action === 'ping') {
            sendPing();
          } else {
            privateHandler(msg, dispatch);
          }
        });

        socket.open((err) => {
          if (err) {
            // an error has occurred
            dispatch(serverOff());
          } else {
            // the connection was successfully established
            dispatch(socketReady());
          }
        });
      }

      interval = setInterval(sendPing, 10 * 1000);
    }
  };

  ws = {
    socket: socket,
    sendMessage,
    reconnectTrigger,
    init,
  };

  return (
    <WebSocketContext.Provider value={ws}>{children}</WebSocketContext.Provider>
  );
};

const publicHandler = (event, dispatch) => {
  const payload = event.data;
  // console.log(payload)
  if (!payload) return;
  switch (payload.id) {
    case 6666:
      dispatch(receiveReregister(true));
      break;
    case 1101:
      dispatch(receive1101(payload));
      break;
    case 3211:
      if (payload.sym && payload.sym.includes('VN30F'))
        dispatch(receive3211(payload));
      break;
    case 3210:
      _process3210(payload);
      break;
    case 3220:
    case 3223:
      _process3220(payload);
      if (payload.sym.startsWith('VN30')) {
        // dispatch mess 3220
        dispatch(receive3220(payload));
      }
      break;
    case 3250:
      _process3250(payload);
      break;
    case 9100:
      _process9100(payload);
      break;
    // case 3310:
    //   // console.log('3310', payload);
    //   // emit(receive3310(payload));
    //   break;

    // lô lẻ
    case 6210:
      _process6210(payload);
      break;
    case 6220:
      _process6220(payload);
      break;
    default:
      break;
  }
};

const privateHandler = (event, dispatch) => {
  const payload = event.data;
  const action = event.action;

  // console.log(payload);

  if (action === 'logout') {
    localStorage.removeItem('token');
    sessionStorage.removeItem('authen');
    dispatch({ type: 'CLIENT_UNSET' });
  }

  if (action === 'Event') {
    // process event lenh
    dispatch({ type: 'Event', resData: payload });
  } else {
    // other private event
    const _apiValid = handlePrivateApiErrors(payload, action);
    // console.log(_apiValid)
    if (_apiValid.status) {
      if (action === 'ListAccount') {
        const resData = _apiValid.data;
        let listAccount = [],
          defaultAccount;
        console.log(resData.normal);
        if (resData && resData.normal && !!resData.normal.length) {
          resData.normal.forEach((element) => {
            const opts = {
              value: element.subAcntNo,
              label:
                element.subAcntNo +
                ' - ' +
                (element.subAcntNo.startsWith('M') ? 'Margin' : 'Thường'),
              acntNo: element.acntNo,
              subAcntNo: element.subAcntNo,
              vsdAcntNo: element.vsdAcntNo,
              isDefSubAcnt: element.isDefSubAcnt,
            };
            listAccount.push(opts);
            if (element.isDefSubAcnt) defaultAccount = opts;
          });
        }
        dispatch({ type: 'ListAccount', resData: listAccount });
        dispatch({ type: 'DefaultAccount', resData: defaultAccount });
      } else if (action === 'getSymbolInfo') {
        // console.log(_apiValid)
        const _dt = {
          list: _apiValid.data.list ? [..._apiValid.data.list] : [],
          dataMargin: _apiValid.dataMargin ? _apiValid.dataMargin : null,
        };
        dispatch({ type: event.action, resData: _dt });
      } else if (action !== 'ping') {
        dispatch({ type: event.action, resData: _apiValid.data });
      }
    } else {
      dispatch({ type: _apiValid.type, resData: _apiValid.data });
    }
  }
};

const ab2str = (buf) => {
  var byteArray = new Uint8Array(buf);
  var obj = deserialize(byteArray);

  return obj;
};

const str2ab = (str) => {
  var buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  var bufView = new Uint8Array(buf);
  for (var i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
};
